import { useTheme } from "@emotion/react";
import { Box } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import { useWindowSize } from "../../utils";

const dataset = [
    { year: 2000, series1: 10, series2: 15, series3: 5 },
    { year: 2005, series1: 20, series2: 25, series3: 15 },
    { year: 2010, series1: 30, series2: 35, series3: 25 },
    { year: 2015, series1: 40, series2: 45, series3: 35 },
    { year: 2020, series1: 50, series2: 55, series3: 45 },
];

const LineChartBox = () => {
    const theme = useTheme();

    const { width } = useWindowSize();

    return (
        <Box
            sx={{
                bgcolor: 'white',
                boxShadow: 1,
                border: 1,
                borderColor: theme.palette.customGrey.borderInput,
                backgroundColor: 'white',
                borderRadius: 1,
                width: '100%',
            }}>
            <LineChart
                width={width - 280}
                height={300}
                dataset={dataset}
                xAxis={[
                    {
                        id: 'Years',
                        dataKey: 'year',
                        scaleType: 'linear',
                        valueFormatter: (year) => year.toString(),
                    },
                ]}
                series={[
                    {
                        id: 'Series 1',
                        dataKey: 'series1',
                        stack: 'total',
                        area: true,
                        showMark: false,
                        color: '#007bff',
                    },
                    {
                        id: 'Series 2',
                        dataKey: 'series2',
                        stack: 'total',
                        area: true,
                        showMark: false,
                        color: '#ff5733',
                    },
                    {
                        id: 'Series 3',
                        dataKey: 'series3',
                        stack: 'total',
                        area: true,
                        showMark: false,
                        color: '#28a745',
                    },
                ]}
            />
        </Box>
    );
}

export default LineChartBox;
